module.exports = {
	"header": "Fonctionnalités",
	"headerSmall": "Publiez vos encans sur $t(general::brand)",
	"pricing": "Prix __type__",
	"auctionSetup": {
		"header": "Configuration des encans",
		"lotLimit": "Nombre de lots par encan:",
		"pictureLimit": "Nombre de photos par lot:",
		"imageHosting": "Hébergement des photos"
	},
	"marketing": {
		"header": "Promotion",
		"orgPremium": "Votre entreprise listée en premier dans l'annuaire",
		"auctionPremium": "Vos encans affichés en primeur pour plus de visibilité"
	},
	"support": {
		"header": "Soutien",
		"catalogProduction": "Soutien pour la production du catalogue",
		"catalogProductionTooltip": "Nous pouvons fournir du soutien direct au téléphone ou par courriel pour la création et la gestion de votre catalogue d'encan.",
		"phone": "Soutien téléphonique",
		"email": "Soutien par courriel"
	},
	"soon": {
		"header": "Fonctionnalité à venir",
		"availableSoon": "Cette fonctionnalité va être disponible bientôt. Revenez plus tard.",
		"contactUs": "Pour plus d'information vous pouvez <a>nous contacter</a>."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/features.json5
// module id = 1982
// module chunks = 6